__turbopack_context__.v({
  "activeFilters": "Recipes-module-scss-module__HDrpdG__activeFilters",
  "activeFiltersTransition": "Recipes-module-scss-module__HDrpdG__activeFiltersTransition",
  "clearAllButton": "Recipes-module-scss-module__HDrpdG__clearAllButton",
  "fade-in": "Recipes-module-scss-module__HDrpdG__fade-in",
  "filtersContainer": "Recipes-module-scss-module__HDrpdG__filtersContainer",
  "filtersTransition": "Recipes-module-scss-module__HDrpdG__filtersTransition",
  "header": "Recipes-module-scss-module__HDrpdG__header",
  "heading": "Recipes-module-scss-module__HDrpdG__heading",
  "hero": "Recipes-module-scss-module__HDrpdG__hero",
  "heroTransition": "Recipes-module-scss-module__HDrpdG__heroTransition",
  "isSearch": "Recipes-module-scss-module__HDrpdG__isSearch",
  "isVisible": "Recipes-module-scss-module__HDrpdG__isVisible",
  "navButton": "Recipes-module-scss-module__HDrpdG__navButton",
  "navLabel": "Recipes-module-scss-module__HDrpdG__navLabel",
  "noSearchResults": "Recipes-module-scss-module__HDrpdG__noSearchResults",
  "root": "Recipes-module-scss-module__HDrpdG__root",
  "searchQuery": "Recipes-module-scss-module__HDrpdG__searchQuery",
});
